(<template>
  <div id="monument-details" :class="style" v-if="monument">
    <h2 >{{monument.name}}</h2>
    <strong v-translate>Rating</strong>
    <el-rate v-model="monument.rating"
             disabled
             show-score
             text-color="#ff9900"
             :score-template="points"></el-rate>
    <br />
    <el-tabs type="card">
      <el-tab-pane>
        <div slot="label">
          <i class="el-icon-fa-image"></i>&nbsp;
          <span v-translate>Images</span>
        </div>
        <el-carousel ref="mainCarousel"
                     trigger="click"
                     class="image-container"
                     @change="(newIndex, oldIndex) => { previewImageIndex = newIndex }"
                     :autoplay="false"
                     height="50vh">
          <el-carousel-item class="image-container-item" v-for="image in monument.images" :key="image">
            <img :src="image" @click="isImagePreviewVisible=true"/>
          </el-carousel-item>
        </el-carousel>
      </el-tab-pane>
      <el-tab-pane>
        <div slot="label">
          <i class="el-icon-fa-map-marker"></i>&nbsp;
          <span v-translate>Map</span>
        </div>
        <map-view :position="monument.position" :isEditable="false"></map-view>
      </el-tab-pane>
    </el-tabs>
    <br />
    <div v-if="monument.audio[$language.current]">
      <audio controls class="audio-player">
        <source :src="monument.audio[$language.current]" type="audio/mpeg" />
      </audio>
    </div>
    <div v-else>
      <strong v-translate>Audio guide not available in the current language</strong>
      <div v-for="(audio, key) in monument.audio" v-if="audio">
        <span>
          <strong><translate>Language</translate>:</strong>
          {{$language.available[key]}}
        </span>
        <audio  controls class="audio-player">
          <source :src="audio" type="audio/mpeg" />
        </audio>
      </div>
    </div>
    <el-tabs type="card">
      <el-tab-pane>
        <div slot="label">
          <i class="el-icon-fa-info-circle"></i>&nbsp;
          <span v-translate>Details</span>
        </div>
        <div>
          <p>
            <strong v-translate>Description</strong>
          </p>
          <p class="description-style">{{monument.description}}</p>
          <div v-if="monument.urls.length > 0">
            <p>
              <strong v-translate>References</strong><br />
            </p>
            <a v-for="url in monument.urls" :href="url" target="_blank">{{url}}<br /></a>
          </div>
          <p><strong v-translate>Created by</strong>:&nbsp;{{monument.createdBy}}</p>
        </div>
      </el-tab-pane>
      <el-tab-pane>
        <div slot="label">
          <i class="el-icon-fa-comments"></i>&nbsp;
          <span v-translate>Comments</span>
        </div>
        <div v-if="monument.comments">
          <div v-if="monument.comments.length > 0">
            <el-card v-for="comment in monument.comments" :key="comment.id">
              <div class="comment-title" slot="header">
                <span class="comments-user-icon" :style="{background: getColor(comment.createdBy)}">
                  {{comment.createdBy[0].toUpperCase()}}
                </span>
                <div>
                  <strong class="comment-title-content">{{comment.createdBy}}</strong><br />
                  <span class="comment-title-content">{{getDateTime(comment.date)}}</span>
                </div>
              </div>
              <p>{{comment.comment}}</p>
            </el-card>
          </div>
          <div v-else class="center">
            <h3 v-translate>There are no comments :(</h3>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="isImagePreviewVisible" width="95vw" top="4vh">
      <el-carousel v-if="isImagePreviewVisible"
                   trigger="click" class="image-container"
                   :initial-index="previewImageIndex"
                   :autoplay="false"
                   @change="(newIndex, oldIndex) => { $refs.mainCarousel.setActiveItem(newIndex) }"
                   height="80vh">
        <el-carousel-item class="image-container-item" v-for="image in monument.images" :key="image">
          <img :src="image" />
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
    <el-button  v-if="$session.exists() && $route.path !=='/'" size="small" icon="plus" type="primary" @click="renderQrAgain">
          <span v-translate>Generate qr again</span>
        </el-button>
  </div>
</template>)

(<script>
import axios from 'axios'
import MapView from './Map-View.vue'
import StringToColor from 'string-to-color'

export default {
  name: 'monument-detailed-view',
  props: ['id', 'preview'],
  data () {
    var style = this.preview ? 'monument-details' : 'list monument-details'
    return {
      points: `{value} ${this.$gettext('points')}`,
      style,
      monument: null,
      previewImageIndex: 0,
      isImagePreviewVisible: false
    }
  },
  created () {
    this.getMonument().then(monument => {
      this.monument = monument
    }).catch(() => {})
  },
  components: {
    'map-view': MapView
  },
  methods: {
    getColor (string) {
      return `#${StringToColor.generate(string)}`
    },
    getDateTime (dateString) {
      var now = new Date()
      var date = new Date(dateString)
      if (now.getFullYear() === date.getFullYear() && now.getMonth() === date.getMonth() && now.getDate() === date.getDate()) {
        return date.toTimeString().split(' ')[0]
      } else {
        return dateString.slice(0, 10).replace(/-/g, ' ')
      }
    },
    renderQrAgain () {
      return axios({
        method: 'post',
        url: `${process.env.SERVER_URL}/qr/new-qr`,
        headers: {'Content-Type': 'application/json'},
        withCredentials: true,
        data: {id: this.id}
      }).then(response => {
        this.$message({
          type: 'success',
          message: response.data || response.statusText
        })
        this.$emit('close-edit')
      })
      .catch(error => {
        var msg
        if (error.response) {
          msg = error.response.data || error.response.statusText
        } else {
          msg = error.message
        }
        this.$message({
          type: 'error',
          message: msg
        })
      })
    },
    getMonument () {
      return axios({
        method: 'get',
        url: `${process.env.SERVER_URL}/monuments/${this.id}?lang=${this.$language.current}`,
        withCredentials: true
      })
      .then(response => {
        var tmpMonument = response.data
        return this.getMonumentComments().then(comments => {
          tmpMonument.comments = comments
          return tmpMonument
        }).catch(error => {
          return error
        })
      })
      .catch(error => {
        var msg
        if (error.response) {
          msg = error.response.data || error.response.statusText
        } else {
          msg = error.message
        }
        this.$message({
          type: 'error',
          message: msg
        })
        return error
      })
    },
    getMonumentComments () {
      return axios({
        method: 'get',
        url: `${process.env.SERVER_URL}/monuments/${this.id}/comments`,
        withCredentials: true
      })
      .then(response => {
        return response.data
      })
      .catch(error => {
        var msg
        if (error.response) {
          msg = error.response.data || error.response.statusText
        } else {
          msg = error.message
        }
        this.$message({
          type: 'error',
          message: msg
        })
        return error
      })
    }
  }
}
</script>)

(<style>
.monument-details {
  padding-bottom: 6em;
  margin: auto;
  text-align: left;
  line-height: 20px;
}
.preview-menu-item {
  width: 50%;
}
.description-style {
  text-align: justify;
}
.audio-player {
  width: 100%;
}
.image-container {
  width: 100%;
}
.image-container-item {
  text-align: center;
  background: grey;
}
.image-container-item > img {
  height: 100%;
}
.comment-title {
  width: 100%;
  display: -webkit-flex;
  display: flex;
  line-height: 20px;
}
.comment-title-content {
  padding: 10px;
}
.comments-user-icon {
  width: 2em;
  height: 2em;
  line-height: 2em;
  display: block;
  border-radius: 50%;
  text-align: center;
  color: white;
}
.center {
  text-align: center;
}
</style>)



// WEBPACK FOOTER //
// src/components/Monument-Detailed-View.vue